import { useEffect, useRef } from 'react';

/**
 *
 * @description 定时器
 * @param {function} callback 回调函数
 * @param {number} delay 时间（传null则清除当前定时器）
 *
 */
function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    }
    if (delay) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default useInterval
